import React from 'react'




const EmptyState = ({header,content,noImage,img})=>{

    return(
        <div style={{display: 'flex', alignItems: 'center', width: '100%', flexDirection: 'column', margin: 'auto'}}>
            <span className="empty-state-text">{header}</span>
            <img src={img} style={{width: 400, height:300, visibility: noImage? 'hidden' : 'visible'}}/>
            <span className="empty-state-sub-text">{content}</span>
        </div>
    )
}

export default EmptyState 